import React from 'react';

/**
 * Shimmer placeholder for the Stories discovery screen while /discover loads —
 * a hero block plus a few carousel rows. Pure markup; CSS drives the shimmer.
 */
export default function MovementSkeleton() {
  return (
    <div className="ms-skel" aria-hidden="true">
      <div className="ms-skel-hero ms-shimmer" />
      {[0, 1, 2].map(row => (
        <div className="ms-skel-row" key={row}>
          <div className="ms-skel-title ms-shimmer" />
          <div className="ms-skel-track">
            {[0, 1, 2, 3].map(c => <div className="ms-skel-card ms-shimmer" key={c} />)}
          </div>
        </div>
      ))}
    </div>
  );
}
